import { render, staticRenderFns } from "./PackageLimitDialog.vue?vue&type=template&id=40d92841"
import script from "./PackageLimitDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageLimitDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PackageLimitDialog.vue?vue&type=style&index=0&id=40d92841&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d92841')) {
      api.createRecord('40d92841', component.options)
    } else {
      api.reload('40d92841', component.options)
    }
    module.hot.accept("./PackageLimitDialog.vue?vue&type=template&id=40d92841", function () {
      api.rerender('40d92841', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globalDialog/PackageLimitDialog.vue"
export default component.exports